export const HOTEL_SAVED_CARD_RETURN_CHANNEL = 'ths-hotel-saved-card-return';
const source = crypto.randomUUID();

export function isHotelSavedCardsChange(data: unknown) {
  return (
    data === 'returned' ||
    (typeof data === 'object' &&
      data !== null &&
      'type' in data &&
      data.type === 'changed' &&
      'source' in data &&
      data.source !== source)
  );
}

export function notifyHotelSavedCardsChanged() {
  if (typeof BroadcastChannel === 'undefined') return;
  const channel = new BroadcastChannel(HOTEL_SAVED_CARD_RETURN_CHANNEL);
  channel.postMessage({ type: 'changed', source });
  channel.close();
}
